import { render, staticRenderFns } from "./TenantEntry.vue?vue&type=template&id=99823e46&scoped=true"
import script from "./TenantEntry.vue?vue&type=script&lang=js"
export * from "./TenantEntry.vue?vue&type=script&lang=js"
import style0 from "./TenantEntry.vue?vue&type=style&index=0&id=99823e46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99823e46",
  null
  
)

export default component.exports